import React, { useEffect, useMemo, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useSelector } from "react-redux";
import { useCalendarDays } from "../../hooks/useCalendarDays";
import moment from "moment";
import axios from "axios";
import clientConfig from "../../env";
import { toast } from "react-toastify";
import { uuid } from "uuidv4";
import { MdLocalPhone, MdOutlineVideocam } from "react-icons/md";
import CustomTooltip from "../toolTips/tooltips.components";
import { BsInfoCircle } from "react-icons/bs";
import intlLocaleInfo from "../../constants/intlLocaleInfo";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { IoMdCloseCircle } from "react-icons/io";
import { ReactComponent as Logo } from "../../logo.svg";

export const formatDateString = (dateString) => {
  const formattedDate = moment
    .utc(dateString.toLocaleString())
    .format("YYYY-MM-DD");
  return formattedDate;
};

const ScheduleCallPopupNew = ({
  userid,
  firstname,
  lastname,
  email,
  profile_picture,
  popupvisible,
  sendDataToParentSchedule,
  callScheduled,
  requestFromMyConnection,
  senderId,
  senderTimeZone,
  scheduleLocale,
  displayRequestCall = true,
  displayClosebtn = true,
  ...props
}) => {
  const senderuserId = useSelector((state) => state.user.userId);
  const token = useSelector((state) => state.user.token);
  const userfirstname = useSelector((state) => state.user.firstName);
  const userlastname = useSelector((state) => state.user.lastName);
  const useremail = useSelector((state) => state.user.email);
  const userprofile = useSelector((state) => state.user.profile_picture);
  const headline = useSelector((state) => state.user.headline);
  const industry = useSelector((state) => state.user.industry);
  const interested_in = useSelector((state) => state.user.interested_in);
  const country = useSelector((state) => state.user.country);
  const city = useSelector((state) => state.user.city);
  const state = useSelector((state) => state.user.state);
  const organization = useSelector((state) => state.user.organization);
  const university = useSelector((state) => state.user.university);
  const classification = useSelector((state) => state.user.classification);
  const scheduleSettings = useSelector(
    (state) => state.user?.scheduleMeetingSettings
  ); // Current login user ScheduleSettings

  const [currentSelectedMonth, setCurrentSelectedMonth] = useState(
    new Date().getMonth()
  );
  const [currentSelectedYear, setCurrentSelectedYear] = useState(
    new Date().getFullYear()
  );
  const [startTimes, setStartTimes] = useState([]);
  const [userProfile, setUserProfile] = useState(null);
  const [dateState, setDateState] = useState(null);
  const [timeState, setTimeState] = useState();
  const [requestTrigger, setRequestTrigger] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [communicationType, setCommunicationType] = useState("phone");
  const [durationOptions, setDurationOption] = useState([]);
  const [durationState, setDurationState] = useState(15);
  const [inpersonLocationValue, setInpersonLocationValue] = useState(null);
  const [userSelectedDays, setUserSelectedDays] = useState([]);
  const [dynamicDropdownOptions, setDynamicDropdownOptions] = useState([]);
  const [originalDynamicDropdownOptions, setOriginalDynamicDropdownOptions] =
    useState([]);
  const [startTimeDynamicOption, setStartTimeDynamicOption] = useState([]);
  const [originalStartTimeOptionList, setOriginalStartTimeOptionList] =
    useState([]);
  const [availableDates, setAvailableDates] = useState([]);
  const [profileUserAvailableDays, setProfileUserAvailableDays] = useState([]);

  const startTimeDynamicOptionList = [];

  const { getDays: getDaysfn } = useCalendarDays({
    availabilityHour: props?.availabilityHour,
    profileUserTimeZone: props.scheduleTimezone,
    loginUserTimeZone: scheduleSettings?.timeZone?.value || senderTimeZone,
    startTimeDynamicOptionList: startTimeDynamicOptionList,
    currentDate: dateState,
  });

  const handleClickDay = (value) => {
    const unformattedDateStr = `${value.getFullYear()}-${String(
      value.getMonth() + 1
    ).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`;
    const selectedDate = moment
      .tz(unformattedDateStr, scheduleSettings?.timeZone?.value)
      .format("YYYY-MM-DDTHH:mm:ss");
    setDateState(selectedDate);
  };

  const calculateEndTime = (starttime, duration) => {
    let formatted = moment(starttime, ["h:mm A"]).format("hh:mm a");
    if (+duration === 1) {
      setEndTime(
        moment(formatted, "hh:mm:ss A").add(duration, "hour").format("hh:mm A")
      );
    } else {
      setEndTime(
        moment(formatted, "hh:mm:ss A")
          .add(duration, "minute")
          .format("hh:mm A")
      );
    }
  };

  useEffect(() => {
    // if (!props?.scheduleSettings) {
    //   if (!profileUserAvailableDays?.length) {
    //     setProfileUserAvailableDays(
    //       props.availabilityHour?.map((d) => parseInt(d.selecteDay))
    //     );
    //   }
    //   if (!originalStartTimeOptionList.length) {
    //     setOriginalStartTimeOptionList(startTimeDynamicOptionList);
    //     const startTime = JSON.parse(
    //       JSON.stringify(startTimeDynamicOptionList)
    //     );
    //     const availableDays = [
    //       ...new Set(startTime.map((item) => item.day)),
    //     ].map((day) => moment().day(day).day());

    //     setUserSelectedDays(availableDays);
    //   }
    // }
  }, [startTimeDynamicOptionList]);

  useEffect(() => {
    if (originalStartTimeOptionList?.length) {
      const startTime = JSON.parse(JSON.stringify(originalStartTimeOptionList));
      const availableDates = [...new Set(startTime.map((item) => item.date))];
      const timeZone = scheduleSettings?.timeZone?.value; // Assuming this is correctly defined
      const currentDate = moment.tz(timeZone); // Assuming this is correctly defined
      const datesList = availableDates.filter((dateStr) => {
        // Assuming `dateStr` is in ISO 8601 format (YYYY-MM-DD)
        const dateToCheck = moment.tz(dateStr, timeZone).startOf("day"); // Use start of day to strip time component
        return dateToCheck.isSameOrAfter(currentDate.startOf("day")); // Compare only dates
      });
      setAvailableDates(datesList);
    }
  }, [originalStartTimeOptionList]);

  useEffect(() => {
    // if (props?.scheduleSettings) {
    //   if (durationState === "30") {
    //     const newOptions = [...originalDynamicDropdownOptions];
    //     const lastItem = newOptions.splice(-1);
    //     setDynamicDropdownOptions(newOptions);
    //     if (startTime === lastItem[0]?.key) {
    //       setStartTime(newOptions[newOptions.length - 1]?.key);
    //       calculateEndTime(
    //         newOptions[newOptions.length - 1]?.key,
    //         durationState
    //       );
    //     }
    //   } else if (durationState === "1") {
    //     const newOptions = [...originalDynamicDropdownOptions];
    //     const lastItems = newOptions.splice(-3);
    //     setDynamicDropdownOptions(newOptions);
    //     const itemExist = lastItems.find((i) => i?.key === startTime);
    //     if (itemExist) {
    //       setStartTime(newOptions[newOptions.length - 1]?.key);
    //       calculateEndTime(
    //         newOptions[newOptions.length - 1]?.key,
    //         durationState
    //       );
    //     }
    //   } else {
    //     setDynamicDropdownOptions(originalDynamicDropdownOptions);
    //   }
    // } else if (!props?.scheduleSettings) {
    //   if (durationState === "30") {
    //     const startTimedropdowns = JSON.parse(
    //       JSON.stringify(originalStartTimeOptionList)
    //     );
    //     const uniqueSet = new Set(
    //       startTimedropdowns
    //         .filter((option) => formatDateString(dateState) === option.date)
    //         .map((item) => JSON.stringify(item))
    //     );
    //     const uniqueList = Array.from(uniqueSet, (item) => JSON.parse(item));

    //     const itemFoundIndex = uniqueList.findLastIndex(
    //       (i) => i.time.split(" ")[0].split(":")[1] === "30"
    //     );

    //     if (
    //       parseFloat(startTime.replace(":", ".")) >
    //       parseFloat(uniqueList[uniqueList.length - 1]?.time.replace(":", "."))
    //     ) {
    //       setStartTime(uniqueList[itemFoundIndex]?.time);
    //       calculateEndTime(uniqueList[itemFoundIndex]?.time, durationState);
    //     }
    //   } else if (durationState === "1") {
    //     const startTimedropdowns = JSON.parse(
    //       JSON.stringify(originalStartTimeOptionList)
    //     );
    //     const uniqueSet = new Set(
    //       startTimedropdowns
    //         .filter((option) => formatDateString(dateState) === option.date)
    //         .map((item) => JSON.stringify(item))
    //     );
    //     const uniqueList = Array.from(uniqueSet, (item) => JSON.parse(item));

    //     const itemFoundIndex = uniqueList.findLastIndex(
    //       (i) => i.time.split(" ")[0].split(":")[1] === "00"
    //     );
    //     uniqueList.splice(itemFoundIndex + 1, uniqueList.length);

    //     setStartTimeDynamicOption(uniqueList);
    //     if (
    //       parseFloat(startTime.replace(":", ".")) >
    //       parseFloat(uniqueList[uniqueList.length - 1]?.time.replace(":", "."))
    //     ) {
    //       setStartTime(uniqueList[uniqueList.length - 1]?.time);
    //       calculateEndTime(
    //         uniqueList[uniqueList.length - 1]?.time,
    //         durationState
    //       );
    //     }
    //   } else {
    //     const startTime = JSON.parse(
    //       JSON.stringify(originalStartTimeOptionList)
    //     );
    //     const uniqueSet = new Set(
    //       startTime
    //         .filter((option) => formatDateString(dateState) === option.date)
    //         .map((item) => JSON.stringify(item))
    //     );
    //     const uniqueList = Array.from(uniqueSet, (item) => JSON.parse(item));

    //     setStartTimeDynamicOption(uniqueList);
    //   }
    // }
  }, [durationState]);

  useEffect(() => {
    setDurationOption(props.durationOptions);
  }, [props?.durationOptions]);

  useEffect(() => {
    if (senderId) {
      getUserInfobyId(senderId);
    }
  }, [senderId]);

  useEffect(() => {
    // if (props?.availabilityHour?.length && props.scheduleSettings) {
    //   const days = availableDays(props?.availabilityHour);
    //   setUserSelectedDays(days);
    //   const availableDates = getAvailableDates(days);
    //   setAvailableDates(availableDates);

    //   // const nextavailableDate = new Date(availableDates[0]); // OLD
    //   const nextavailableDate = moment(availableDates[0])
    //     .tz(scheduleSettings?.timeZone?.value)
    //     .toDate();
    //   // setDateState(nextavailableDate);
    //   // handleClickDay(nextavailableDate);
    //   // getStartTimeDropdownOption(nextavailableDate, days);
    //   // getStartTimeDropdownOption(currentDate, days);
    // }
  }, [props?.availabilityHour]);

  useEffect(() => {
    const selectedDays = props?.availabilityHour?.map((item) =>
      parseInt(item.selecteDay)
    );
    const availabilities = [];
    props?.availabilityHour?.forEach((item) => {
      availabilities["_" + parseInt(item.selecteDay)] = {
        start: parseInt(item.startTime),
        end: parseInt(item.endTime),
      };
    });

    const calendarAvailableDates = getCalendarDates(
      currentSelectedYear,
      currentSelectedMonth,
      props?.scheduleTimezone,
      selectedDays,
      availabilities
    );
    let allIntervals = [];
    for (let i = 0; i < calendarAvailableDates.length; i++) {
      const _availability = calendarAvailableDates[i];
      const _intervals = generateTimeIntervals(
        _availability.date.split("T")[0],
        props?.scheduleTimezone,
        scheduleSettings?.timeZone?.value || senderTimeZone,
        _availability.start,
        _availability.end,
        durationState === "1" || durationState === 1 ? 60 : durationState
      );
      allIntervals.push(..._intervals);
    }
    setStartTimes(allIntervals);
  }, [
    props?.scheduleTimezone,
    scheduleSettings,
    durationState,
    currentSelectedYear,
    currentSelectedMonth,
  ]);

  const availableCalendarDays = useMemo(() => {
    const selectedYearMonth = `${currentSelectedYear}-${String(
      currentSelectedMonth + 1
    ).padStart(2, "0")}`;

    const currentTimezone = scheduleSettings?.timeZone?.value || senderTimeZone;
    const currentDate = moment().tz(currentTimezone).startOf("day");

    const filteredStartTimes = [];
    startTimes?.forEach((item) => {
      const givenDate = moment
        .tz(item.targetDate, "YYYY-MM-DD", currentTimezone)
        .startOf("day");
      if (
        item.target?.startsWith(selectedYearMonth) &&
        !givenDate.isBefore(currentDate)
      ) {
        filteredStartTimes.push(item.targetDate);
      }
    });
    const _filteredStartTimes = [...new Set(filteredStartTimes)];

    if (!dateState && _filteredStartTimes.length > 0) {
      handleClickDay(
        moment.tz(_filteredStartTimes[0], currentTimezone).toDate()
      );
    }
    return _filteredStartTimes;
  }, [startTimes, currentSelectedYear, currentSelectedMonth, scheduleSettings]);

  const startTimesItems = useMemo(() => {
    const selectedDate = dateState?.split("T")[0];
    const filteredStartTimes = [];
    startTimes?.forEach((item) => {
      if (item.target?.startsWith(selectedDate)) {
        filteredStartTimes.push(item.targetTime);
      }
    });

    if (filteredStartTimes?.length && !endTime) {
      const starttime = filteredStartTimes[0];
      setStartTime(starttime);
      calculateEndTime(starttime, durationState);
    }

    return filteredStartTimes;
  }, [startTimes, dateState, durationState]);

  const getUserInfobyId = (userId) => {
    axios
      .get(`${clientConfig.siteUrl}wl/v1/user/${userId}`)
      .then((response) => {
        if (response.status === 200) {
          console.log(response);
          const {
            id,
            first_name,
            last_name,
            email,
            profile_picture,
            headline,
            industry,
            interested_in,
            country,
            city,
            state,
            organization,
            university,
            classification,
          } = response?.data;
          const profileData = {
            senderId: id,
            userfirstname: first_name,
            userlastname: last_name,
            useremail: email,
            userprofile: profile_picture,
            headline: headline,
            industry: industry,
            interested_in: interested_in,
            country: country,
            city: city,
            state: state,
            organization: organization,
            university: university,
            classification: classification,
            timeZone: response.data["schedule-meeting-settings"].timeZone.value,
          };
          setUserProfile(profileData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const sendRequest = () => {
    setRequestTrigger(!requestTrigger);
    const formattedDate = formatDateString(dateState);
    const formatStartTime = moment(startTime, "HH:mm A").format("HH:mm");
    const startTimeLoginUser = moment.tz(
      `${formattedDate} ${
        parseInt(formatStartTime) < 10 ? `${formatStartTime}` : formatStartTime
      }:00`,
      scheduleSettings?.timeZone?.value ?? senderTimeZone
    );

    const startTimeInUTC = startTimeLoginUser.clone().utc();
    const utcCallDate = startTimeInUTC.format("YYYY-MM-DD");
    const utcCallStartTime = startTimeInUTC.format("hh:mm A");
    const utcCallEndTime = moment(utcCallStartTime, "hh:mm A")
      .add(+durationState, +durationState === 1 ? "hours" : "minutes")
      .format("hh:mm A");

    const startTimeProfileUser = startTimeInUTC
      .clone()
      .tz(props.scheduleTimezone);

    // const startTimeProfileUser = startTimeInUTC;

    const callDate = startTimeProfileUser.format("YYYY-MM-DD");
    const callStartTime = startTimeProfileUser.format("hh:mm A");
    const endTimeProfileUser = moment(callStartTime, "hh:mm A").add(
      +durationState,
      +durationState === 1 ? "hours" : "minutes"
    );
    const callEndTime = endTimeProfileUser.format("hh:mm A");
    const uuId = uuid();

    const inpersonData =
      communicationType === "in-person"
        ? {
            meetinglink: inpersonLocationValue,
          }
        : {};

    const requestInfo = {
      sender_id: senderuserId ? senderuserId : userProfile?.senderId,
      senderemail: useremail ? useremail : userProfile?.useremail,
      senderTimezone: scheduleSettings?.timeZone?.value,
      request_user_id: userid,
      requestemail: email,
      date: moment(formatDateString(dateState)).format("LL"),
      duration: [15, 30].includes(+durationState)
        ? `${durationState} mins`
        : `${durationState} hour`,
      start_time: startTime,
      end_time: endTime,
      requestFromMyConnection: requestFromMyConnection,
      communicationType: communicationType,
      meeting_date: `${formatDateString(dateState)} ${moment(endTime, [
        "h:mm:ss A",
      ]).format("hh:mm:ss")}`,
      meeting_id: uuId,
      receiver_start_time: callStartTime,
      receiver_end_time: callEndTime,
      receiver_meeting_date: `${callDate} ${moment(callEndTime, [
        "h:mm:ss A",
      ]).format("hh:mm:ss")}`,
      utc_start_time: utcCallStartTime,
      utc_end_time: utcCallEndTime,
      utc_meeting_date: `${utcCallDate} ${moment(utcCallEndTime, [
        "h:mm:ss A",
      ]).format("HH:mm:ss")}`,
      ...inpersonData,
    };

    let data = {
      sender_id: senderuserId ? senderuserId : userProfile?.senderId,
      sendername: `${
        userfirstname ? userfirstname : userProfile?.userfirstname
      } ${userlastname ? userlastname : userProfile?.userlastname}`,
      senderemail: useremail ? useremail : userProfile?.useremail,
      senderTimezone: scheduleSettings?.timeZone?.value ?? senderTimeZone,
      senderprofile: {
        image: userprofile ? userprofile : userProfile?.userprofile,
        headline: headline ? headline : userProfile?.headline,
        industry: industry ? industry : userProfile?.industry,
        interested_in: interested_in
          ? interested_in
          : userProfile?.interested_in,
        classification: classification
          ? classification
          : userProfile?.classification,
        country: country ? country : userProfile?.country,
        city: city ? city : userProfile?.city,
        state: state ? state : userProfile?.state,
        university: university ? university : userProfile?.university,
        organization: organization ? organization : userProfile?.organization,
      },
      request_user_id: userid,
      requestname: `${firstname} ${lastname}`,
      requestemail: email,
      date: moment(callDate).format("LL"),
      duration: [15, 30].includes(+durationState)
        ? `${durationState} mins`
        : `${durationState} hour`,
      time: timeState,
      start_time: callStartTime,
      end_time: callEndTime,
      communicationType: communicationType,
      meeting_id: uuId,
      httpURL: window.location.origin,
      requestInfo: window.btoa(JSON.stringify(requestInfo)),
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Barer ${token}`,
    };

    axios
      .post(`${clientConfig.siteUrl}wl/v1/send-call-request`, data, {
        headers: headers,
      })
      .then((response) => {
        toast.success(response.data.message);
        sendDataToParentSchedule(!popupvisible);
        axios
          .post(
            `${clientConfig.siteUrl}wl/v1/connection-request-pending`,
            {
              request_user_id: userid,
              sender_id: senderuserId ? senderuserId : senderId,
              meeting_date: `${utcCallDate} ${moment(utcCallEndTime, [
                "hh:mm:ss A",
              ]).format("HH:mm:ss")}`, // need to update dateTime into UTC
              meeting_id: uuId,
            },
            {
              headers: headers,
            }
          )
          .then((response) => {
            callScheduled(true);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  const durationOptionUI = () => {
    return (
      <div className="form-row input-group m-0">
        {durationOptions.map((item, index) => (
          <div
            key={index}
            className={`duration-wrapper1 form-group mb-0 p-0 col-md-${Math.floor(
              12 / durationOptions.length
            )} ${
              index === 0
                ? "input-group-prepend"
                : durationOptions.length === index
                ? "input-group-append"
                : ""
            }`}
          >
            <label
              className={`form-check-label btn btn-outline-secondary w-100 d-flex align-items-center justify-content-between rounded-0 ${
                +durationState === +item?.value ? "active" : ""
              }`}
              htmlFor={`radio${item?.value}min`}
            >
              {parseInt(item?.value) !== 1
                ? `${item?.value} min`
                : `${item?.value} hour`}
              {/* <span className="radio-indicator"></span> */}
              <input
                type="radio"
                name="duration"
                id={`radio${item?.value}min`}
                value={item?.value}
                onChange={(e) => {
                  setDurationState(e.target.value);
                  calculateEndTime(startTime, e.target.value);
                }}
                checked={+durationState === +item?.value ? true : false}
                // className="sr-only"
              />
            </label>
          </div>
        ))}
      </div>
    );
  };

  const communicationTypeUI = () => {
    const icons = (type) => {
      switch (type) {
        case "phone":
          return <MdLocalPhone size={18} className="mr-2" />;
        case "video":
          return <MdOutlineVideocam size={18} className="mr-2" />;
        case "in-person":
          // return <MdOutlinePersonPinCircle size={20} className="mr-2" />;
          return null;
        default:
          return null;
      }
    };

    return props?.communicationOptions?.length
      ? props?.communicationOptions?.map((item, index) => (
          <div
            className={`form-group mb-0 p-0 ${
              index === 0
                ? "input-group-prepend"
                : index === props?.communicationOptions.length - 1
                ? "input-group-append"
                : "input-group"
            } col-6 col-md-${Math.floor(
              12 / props?.communicationOptions.length
            )}`}
            key={item.value}
          >
            {item.value === "in-person" && !requestFromMyConnection ? (
              <CustomTooltip
                title="In-Person Only For Connections"
                className="btn p-0 position-absolute mt-n2"
                style={{
                  right: -5,
                  zIndex: 3,
                  backgroundColor: "#ffffff",
                  borderRadius: "50%",
                }}
              >
                <BsInfoCircle size={14} />
              </CustomTooltip>
            ) : null}
            <label
              className={`form-check-label btn w-100 d-flex align-items-center justify-content-center rounded ${
                communicationType === item.value ? "active" : ""
              } ${
                item.value === "in-person" && !requestFromMyConnection
                  ? "disabled"
                  : ""
              }`}
              htmlFor={`communication${item.value}`}
            >
              {icons(item.value)}
              {item.value}
              <input
                type="radio"
                name="communicationtype"
                id={`communication${item.value}`}
                className="sr-only"
                value={item.value}
                disabled={
                  item.value === "in-person" && !requestFromMyConnection
                    ? true
                    : false
                }
                onChange={() => {
                  console.log(item.value);
                  setCommunicationType(item.value);
                }}
                checked={communicationType === item.value ? true : false}
              />
            </label>
          </div>
        ))
      : null;
  };

  const handleChangeInpersonLocation = (e) => {
    let inpersonValue = e.target.value;
    if (inpersonValue) setInpersonLocationValue(inpersonValue);
    else setInpersonLocationValue(null);
  };

  const getWeekStartCalendarTypeDynamically = (localinfo) => {
    if (!localinfo) return;
    if (localinfo.calendar.includes("islamic")) {
      return "islamic";
    } else if (localinfo.calendar.includes("hebrew")) {
      return "hebrew";
    } else if (localinfo.calendar.includes("indian")) {
      return "iso8601";
    } else if (localinfo.calendar.includes("gregory")) {
      return "gregory";
    } else {
      return "iso8601";
    }
  };

  function getLocaleInfo(localeCode) {
    if (!localeCode) return;

    let payload = {};
    try {
      const locale = new Intl.Locale(localeCode);
      payload = {
        language: locale.language,
        region: locale.region,
        firstDayOfWeek: locale.weekInfo.firstDay, // 0 = Sunday, 1 = Monday, etc.
        minimalDays: locale.weekInfo.minimalDays, // Minimal days for the first week
        calendar: locale.calendars, // Calendar system used (e.g., "gregory" for Gregorian calendar)
      };
    } catch (error) {
      const localInfoPayload = intlLocaleInfo[localeCode];
      payload = {
        minimalDays: undefined,
        ...localInfoPayload,
      };
    }
    return payload;
  }

  // Example: Get locale info for "en-US"
  const localeInfo = getLocaleInfo(scheduleLocale);

  const calendarType = getWeekStartCalendarTypeDynamically(localeInfo);

  const getCalendarDates = (
    year,
    month,
    timeZone,
    availableDays,
    availabilities
  ) => {
    let dates = [];
    let startDate = moment.tz({ year, month: month, day: 1 }, timeZone); // Month is 0-based
    let endDate = startDate.clone().endOf("month"); // Get last day of the month

    while (startDate.isSameOrBefore(endDate, "day")) {
      let weekDay = startDate.isoWeekday();
      if (weekDay === 7) {
        weekDay = 0;
      }

      if (availableDays.includes(weekDay)) {
        dates.push({
          date: startDate.clone().toISOString(true),
          start: parseInt(availabilities["_" + weekDay].start),
          end: parseInt(availabilities["_" + weekDay].end),
        });
      }

      startDate.add(1, "day");
    }

    return dates;
  };

  const generateTimeIntervals = (
    dateStr,
    sourceTZ,
    targetTZ,
    startHour = 5,
    endHour = 17,
    interval = 60
  ) => {
    // Hardcode interval to 15 minutes - as discussed over meeting
    let intervalFixed = 15;
    let times = [];
    const date = moment
      .tz(dateStr, sourceTZ)
      .startOf("day")
      .hour(startHour)
      .minute(0)
      .second(0);

    // Calculate the end time
    const endTime = moment
      .tz(dateStr, sourceTZ)
      .startOf("day")
      .hour(endHour)
      .minute(0)
      .second(0);

    // while (date.hour() < endHour) {
    while (date.clone().add(interval, "minutes").isSameOrBefore(endTime)) {
      times.push({
        source: date.toISOString(true),
        target: date.clone().tz(targetTZ).toISOString(true),
        targetDate: date.clone().tz(targetTZ).format("YYYY-MM-DD"),
        targetTime: date.clone().tz(targetTZ).format("h:mm A"), // Ensures proper formatting
      });
      date.add(intervalFixed, "minutes");
    }

    return times;
  };

  return (
    <React.Fragment>
      <div className={`user_popup_container ${props.className}`}>
        <div className="container-fluid">
          <div className="row position-relative">
            <div className="col-12">
              <div className="user_popup">
                {requestTrigger && <div id="overlay_screen"></div>}
                <div className="row mx-0">
                  <div className="col-12 col-lg-6 py-4" id="calender_panel">
                    <div className="text-center">
                      {profile_picture ? (
                        <div
                          className="user_popup_thumbnail_circle"
                          style={{
                            backgroundImage: `url(${profile_picture})`,
                          }}
                        ></div>
                      ) : (
                        <div className="user_popup_thumbnail_circle">
                          <Logo />
                        </div>
                      )}

                      <h3 className="user_popup_name">
                        {firstname && lastname
                          ? `Meet with ${firstname} ${lastname}`
                          : ""}
                      </h3>
                    </div>
                    <div className="px-3 mt-3">
                      <Calendar
                        className="schedule_calendar"
                        value={dateState}
                        calendarType={calendarType || "iso8601"}
                        minDate={moment
                          .tz(moment(), scheduleSettings?.timeZone?.value)
                          .toDate()}
                        showNeighboringMonth={false}
                        view="month"
                        locale="en"
                        next2Label={null}
                        prev2Label={null}
                        disabled
                        tileDisabled={({ activeStartDate, date, view }) => {
                          getDaysfn(date);
                          const unformattedDateStr = `${date.getFullYear()}-${String(
                            date.getMonth() + 1
                          ).padStart(2, "0")}-${String(date.getDate()).padStart(
                            2,
                            "0"
                          )}`;
                          const currentDayOfCalendar = moment
                            .tz(
                              unformattedDateStr,
                              scheduleSettings?.timeZone?.value
                            )
                            .format("YYYY-MM-DD");
                          return !availableCalendarDays.includes(
                            currentDayOfCalendar
                          );
                        }}
                        onClickDay={handleClickDay}
                        onActiveStartDateChange={({
                          action,
                          activeStartDate,
                          value,
                          view,
                        }) => {
                          setCurrentSelectedMonth(activeStartDate.getMonth());
                          setCurrentSelectedYear(activeStartDate.getFullYear());
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 py-4" id="input_panel">
                    <div className="row">
                      {displayClosebtn ? (
                        requestTrigger ? (
                          <div
                            className="close_popup disabled"
                            aria-disabled="true"
                          >
                            <IoMdCloseCircle size="2em" />
                          </div>
                        ) : (
                          <div
                            className="close_popup"
                            onClick={() =>
                              sendDataToParentSchedule(!popupvisible)
                            }
                          >
                            <IoMdCloseCircle size="2em" />
                          </div>
                        )
                      ) : null}
                      <div className="col-12 pb-2 pb-md-4 pl-4">
                        <div className="mb-4">
                          <h4 className="schedule-title">
                            Current selected date is
                          </h4>
                          <p>{moment(dateState).format("MMMM Do YYYY")}</p>
                        </div>

                        <div className="mb-4">
                          <h4 className="schedule-title">Select Duration:</h4>
                          {durationOptionUI()}
                        </div>

                        <div className="mb-4">
                          <h4
                            className={`schedule-title ${
                              props.nextbtnvisible ? "mb-0" : "mb-2"
                            }`}
                          >
                            Schedule Time:
                          </h4>
                          {props.nextbtnvisible && (
                            <Link
                              to={"/schedule-settings"}
                              style={{
                                fontSize: 14,
                                marginBottom: 10,
                                display: "inline-block",
                              }}
                            >
                              View your schedule settings.
                            </Link>
                          )}

                          <div className="form-row">
                            <div className="col-12 col-md-6">
                              <label htmlFor="starttime" className="mb-0">
                                <small>Start Time *</small>
                              </label>
                              <select
                                name="start_time"
                                id="starttime"
                                required
                                value={startTime}
                                className="form-control"
                                onChange={(e) => {
                                  setStartTime(e.target.value);
                                  calculateEndTime(
                                    e.target.value,
                                    durationState
                                  );
                                }}
                              >
                                {startTimesItems.map((time) => (
                                  <option
                                    key={time}
                                    value={time}
                                    disabled={false}
                                  >
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="col-12 col-md-6">
                              <label htmlFor="endtime" className="mb-0">
                                <small>End Time *</small>
                              </label>
                              <div
                                style={{
                                  padding: "5px 10px",
                                  border: "1px solid #cccccc",
                                  borderRadius: "5px",
                                  color: "#495057",
                                }}
                              >
                                {endTime}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="mb-4">
                          <div className="form-row input-group m-0 communication_type">
                            {communicationTypeUI()}
                          </div>
                          {communicationType === "in-person" ? (
                            <div className="form-group mt-2 mb-0">
                              <label htmlFor="locationdetail_input">
                                Enter Location
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="locationdetail_input"
                                onChange={handleChangeInpersonLocation}
                              />
                            </div>
                          ) : null}
                        </div>
                        {displayRequestCall ? (
                          requestTrigger ? (
                            <>
                              <button
                                type="button"
                                className="btn btn-primary btn-block rounded-10 btn-request-call"
                                disabled
                              >
                                Request A Call
                              </button>
                              <p className="mb-0 mt-2 text-center d-block">
                                Scheduling call, please wait...
                              </p>
                            </>
                          ) : (props?.communicationOptions?.length &&
                              props?.communicationOptions[0]?.value ===
                                "in-person" &&
                              !requestFromMyConnection) ||
                            !availableCalendarDays?.includes(
                              dateState?.split("T")[0]
                            ) ? (
                            <>
                              <button
                                onClick={() => {}}
                                type="button"
                                className="btn btn-primary btn-block rounded-10 btn-request-call"
                                disabled={true}
                              >
                                Request A Call
                              </button>
                              {!availableCalendarDays?.includes(
                                dateState?.split("T")[0]
                              ) ? (
                                <p
                                  className="text-danger text-center mt-2 mb-0"
                                  style={{ fontSize: "small" }}
                                >
                                  Please Select Available Dates.
                                </p>
                              ) : null}
                            </>
                          ) : (
                            <button
                              onClick={sendRequest}
                              type="button"
                              className="btn btn-primary btn-block rounded-10 btn-request-call"
                            >
                              Request A Call
                            </button>
                          )
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ScheduleCallPopupNew;
